export default __webpack_public_path__ + "static/media/chiya_think_tummoc_center.70682486.png";